import { render, staticRenderFns } from "./restBookSummarySetShop_v2.vue?vue&type=template&id=be995a20&scoped=true&"
import script from "./restBookSummarySetShop_v2.vue?vue&type=script&lang=js&"
export * from "./restBookSummarySetShop_v2.vue?vue&type=script&lang=js&"
import style0 from "./restBookSummarySetShop_v2.vue?vue&type=style&index=0&id=be995a20&prod&lang=scss&"
import style1 from "./restBookSummarySetShop_v2.vue?vue&type=style&index=1&id=be995a20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be995a20",
  null
  
)

export default component.exports